
import { defineComponent } from "vue";

export default defineComponent({
  name: "CardWrap",
  setup() {
    return {};
  },
});
